"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arc1 = void 0;
var react_1 = __importDefault(require("react"));
var Arc1 = function (_a) {
    var _b = _a.stroke, stroke = _b === void 0 ? "white" : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? "2" : _c, props = __rest(_a, ["stroke", "strokeWidth"]);
    return (react_1.default.createElement("path", __assign({ d: "M8.00004 10.6667C7.47262 10.6667 6.95705 10.5103 6.51852 10.2173C6.07999 9.92423 5.7382 9.50776 5.53636 9.02049C5.33453 8.53322 5.28172 7.99704 5.38461 7.47976C5.48751 6.96247 5.74148 6.48732 6.11442 6.11438", strokeWidth: strokeWidth, stroke: stroke }, props)));
};
exports.Arc1 = Arc1;
